import { render, staticRenderFns } from "./BroadcastRequestViewer.vue?vue&type=template&id=4a55fdcc&scoped=true"
import script from "./BroadcastRequestViewer.vue?vue&type=script&lang=js"
export * from "./BroadcastRequestViewer.vue?vue&type=script&lang=js"
import style0 from "./BroadcastRequestViewer.vue?vue&type=style&index=0&id=4a55fdcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a55fdcc",
  null
  
)

export default component.exports